export const LinkedInIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.25 22.25"><path d="M4.981 22.25H.368V7.399h4.613ZM2.672 5.368a2.684 2.684 0 1 1 2.672-2.7 2.694 2.694 0 0 1-2.672 2.7ZM22.246 22.25h-4.6v-7.232c0-1.723-.035-3.934-2.4-3.934-2.4 0-2.766 1.872-2.766 3.809v7.356H7.87V7.399h4.424v2.022h.065a4.847 4.847 0 0 1 4.365-2.4c4.669 0 5.527 3.074 5.527 7.068v8.16Z" data-name="Icon awesome-linkedin-in"/></svg>
  );
};
